import { useLocation } from "react-router-dom";

import {
  useDispatchOnMount,
  useDispatchOnUnmount
} from "seneca-common/utils/hooks/dispatch";

import Classroom from "features/classroom/pages/classroom";
import { setCourseId } from "features/classroom/state";
import { resetLastCourseSearchTerm } from "features/classroom/state/actions/meta";
import { useLastLocationOnMount } from "features/common/routing/with-last-location";

import { isInClassroom } from "../../../links";
import usePushCourseInfoToAnalyticsDataLayer from "./analytics/usePushCourseInfoToAnalyticsDataLayer";
import useCourseId from "./hooks/useCourseId";
import useMissingCourseRedirect from "./hooks/useMissingCourseRedirect";
import { getSectionIdIfInSectionRoute } from "./routes/section/links";
import CourseSubRouter from "./routes/SubRouter";

export default function CourseRoute() {
  const location = useLocation();
  const courseId = useCourseId();

  const sectionId = getSectionIdIfInSectionRoute(location);

  const lastLocation = useLastLocationOnMount();
  const locationBeforeEnteringClassroom =
    lastLocation && isInClassroom(lastLocation as any) ? null : lastLocation;

  useMissingCourseRedirect(courseId);
  usePushCourseInfoToAnalyticsDataLayer(courseId, sectionId);

  useDispatchOnMount(setCourseId(courseId));
  useDispatchOnUnmount(resetLastCourseSearchTerm());

  return (
    <Classroom
      courseId={courseId}
      sectionId={sectionId}
      locationBeforeEnteringClassroom={locationBeforeEnteringClassroom}
    >
      <CourseSubRouter />
    </Classroom>
  );
}
